import { ExternalBankAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountInstitution = (
  externalBankAccount: ExternalBankAccount
) => externalBankAccount.institutionName;
